import React, { useEffect } from 'react';
import { useToken } from 'src/modules/User';
import LoadingIndicatorPage from 'src/components/LoadingIndicatorPage';
import { SubmissionPeriodTemplateWizard } from './SubmissionPeriodTemplateWizard';
import { toastError } from 'src/utils/toast';
import { useNavigate, useParams } from 'react-router-dom';
import {
  useFormById,
  useUpdateForm
} from '@120wateraudit/form-builder-components';
import { SUBMISSION_PERIOD_TEMPLATES_PATHS } from '../paths';

const EditSubmissionPeriodTemplateContainer: React.FC<{
  formId: string;
  token: string;
}> = ({ formId, token }) => {
  const navigate = useNavigate();

  const { data: existingForm, isLoading, isError } = useFormById(formId, token);

  const { mutateAsync: editForm, isPending } = useUpdateForm(token);

  useEffect(() => {
    if (!isError) return;
    toastError('Failed to load form.');
    navigate(SUBMISSION_PERIOD_TEMPLATES_PATHS.index);
  }, [isError, navigate]);

  if (isLoading || !existingForm) {
    return <LoadingIndicatorPage />;
  }

  return (
    <SubmissionPeriodTemplateWizard
      token={token}
      edit={true}
      existingForm={existingForm}
      saveForm={editForm}
      isSaving={isPending}
    />
  );
};

const EditSubmissionPeriodTemplatePage: React.FC = () => {
  const { token, isLoading } = useToken();
  const { id: formId } = useParams<{ id: string }>();
  if (isLoading) {
    return <LoadingIndicatorPage />;
  }
  if (!formId) {
    toastError('No form ID provided.');
    return null;
  }
  if (!token) {
    toastError('You must be logged in to edit a form.');
    return null;
  }
  return (
    <EditSubmissionPeriodTemplateContainer formId={formId} token={token} />
  );
};

export default EditSubmissionPeriodTemplatePage;
